import { Redirect, Route, Switch } from "react-router";

import TaskRequestDetail from "./TaskRequestDetail/TaskRequestDetail";
import TaskManagementList from "./TaskManagementList/TaskManagementList";

import { ROUTES } from "../../module/constants";
import { TASKS_URLS } from "./module/constants";
import messages from "./module/messages";
import PageTitle from "../../ui/PageTitle/PageTitle";
import ErrorPage from "../ErrorPage/Loadable";

const TasksManagement = () => {
  return (
    <>
      <PageTitle title={messages.pageTitle} />
      <Switch>
        <Route
          strict
          exact
          path={ROUTES.TASKS}
          component={TaskManagementList}
        />
        <Route
          strict
          exact
          path={TASKS_URLS.TASK_REQUEST_DETAIL}
          component={TaskRequestDetail}
        />
        <Route path={ROUTES.FORBIDDEN} component={ErrorPage} />
        <Redirect path={"*"} to={{ pathname: ROUTES.FORBIDDEN }} />
      </Switch>
    </>
  );
};

export default TasksManagement;
